class UtilsController {
  getAttributes = (featureSet: __esri.FeatureSet | null) => {
    if (!featureSet?.features?.length) return [];

    return featureSet.features.map((feature) => {
      return { ...feature.attributes };
    });
  };
}

const utilsController = new UtilsController();
export default utilsController;
